import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setActivePage } from './features/ui/uiSlice';
import withProps from './hoc/withProps';
import Welcome from './features/welcome/Welcome';
import RealtimeLocation from './features/options/RealtimeLocation';
import PlaceAlerts from './features/options/PlaceAlerts';
import CheckIn from './features/options/CheckIn';
import LocationHistory from './features/options/LocationHistory';
import PanicButton from './features/options/PanicButton';
import SignupScreen from './features/signup/SignupScreen';
import CreatingProfile from './features/family/CreatingProfile';
import SuccessScreen from './features/success/SuccessScreen';
import PlanCheckout from './features/PlanCheckout/PlanCheckout';
import UpsellScreen from './features/plans/UpsellScreen';
import TargetTrack from './features/track/TargetTrack';
import LocationTrack from './features/track/LocationTrack';
import ReasonTrack from './features/track/ReasonTrack';
import TimeTrack from './features/track/TimeTrack';
import FrequencyTrack from './features/track/FrequencyTrack';
import LocationTypeTrack from './features/track/LocationTypeTrack';
import QuantityTrack from './features/track/QuantityTrack';
import FeatureTrack from './features/track/FeatureTrack';
import ExploreSolutions from './features/options/ExploreSolutions';
import PlatformSupport from './features/options/PlatformSupport';
import AboutUs from './features/about/AboutUs';
import landingTypesList from './helper/landingTypes';
import {
    selectBtToken,
    selectPaymentProvider,
    selectPaymentSettingsStatus,
    selectStripePublishKey,
} from './features/signup/signupSlice';
import { usePaymentInit } from 'onboarding-initialization';
import Q2 from './features/questions/Q2';
import Q3 from './features/questions/Q3';
import Q4 from './features/questions/Q4';
import Q5 from './features/questions/Q5';
import Q6 from './features/questions/Q6';
import Q7 from './features/questions/Q7';
import Q8 from './features/questions/Q8';
import Q9 from './features/questions/Q9';
import Q10 from './features/questions/Q10';
import FactOne from './features/facts/FactOne';
import Q11 from './features/questions/Q11';
import Q12 from './features/questions/Q12';
import Q13 from './features/questions/Q13';
import Q14 from './features/questions/Q14';
import FactTwo from './features/facts/FactTwo';
import Q15 from './features/questions/Q15';
import Q16 from './features/questions/Q16';
import Q17 from './features/questions/Q17';
import Q18 from './features/questions/Q18';
import Q19 from './features/questions/Q19';
import Q20 from './features/questions/Q20';
import FactThree from './features/facts/FactThree';
import Q21 from './features/questions/Q21';
import Q22 from './features/questions/Q22';
import Q23 from './features/questions/Q23';

const Router = ({ history }) => {
    const dispatch = useDispatch();
    const settingsStatus = useSelector(selectPaymentSettingsStatus);
    const paymentProvider = useSelector(selectPaymentProvider);
    const stripePk = useSelector(selectStripePublishKey);
    const btToken = useSelector(selectBtToken);
    const initProps = useMemo(() => {
        return {
            settingsStatus,
            paymentProvider,
            stripePk,
            btToken,
            withPaypal: process.env.REACT_APP_ENABLE_PAYPAL === 'true',
        };
    }, [settingsStatus, paymentProvider, stripePk, btToken]);
    const payment = usePaymentInit(initProps);

    const routes = [
        {
            path: landingTypesList,
            component: Welcome,
        },
        {
            path: '/q2',
            component: Q2,
        },
        {
            path: '/q3',
            component: Q3,
        },
        {
            path: '/q4',
            component: Q4,
        },
        {
            path: '/q5',
            component: Q5,
        },
        {
            path: '/q6',
            component: Q6,
        },
        {
            path: '/q7',
            component: Q7,
        },
        {
            path: '/q8',
            component: Q8,
        },
        {
            path: '/q9',
            component: Q9,
        },
        {
            path: '/q10',
            component: Q10,
        },
        {
            path: '/f1',
            component: FactOne,
        },
        {
            path: '/q11',
            component: Q11,
        },
        {
            path: '/q12',
            component: Q12,
        },
        {
            path: '/q13',
            component: Q13,
        },
        {
            path: '/q14',
            component: Q14,
        },
        {
            path: '/f2',
            component: FactTwo,
        },
        {
            path: '/q15',
            component: Q15,
        },
        {
            path: '/q16',
            component: Q16,
        },
        {
            path: '/q17',
            component: Q17,
        },
        {
            path: '/q18',
            component: Q18,
        },
        {
            path: '/q19',
            component: Q19,
        },
        {
            path: '/q20',
            component: Q20,
        },
        {
            path: '/f3',
            component: FactThree,
        },
        {
            path: '/q21',
            component: Q21,
        },
        {
            path: '/q22',
            component: Q22,
        },
        {
            path: '/q23',
            component: Q23,
        },        
        {
            path: '/about-us',
            component: AboutUs
        },
        {
            path: '/choose-target',
            component: TargetTrack,
        },
        {
            path: '/choose-location',
            component: LocationTrack,
        },
        {
            path: '/choose-reason',
            component: ReasonTrack,
        },
        {
            path: '/choose-time',
            component: TimeTrack,
        },
        {
            path: '/choose-frequency',
            component: FrequencyTrack,
        },
        {
            path: '/choose-location-type',
            component: LocationTypeTrack,
        },
        {
            path: '/choose-quantity',
            component: QuantityTrack,
        },
        {
            path: '/choose-feature',
            component: FeatureTrack,
        },
        {
            path: '/explore-solutions',
            component: ExploreSolutions
        },
        {
            path: '/real-time-location',
            component: RealtimeLocation
        },
        {
            path: '/place-alerts',
            component: PlaceAlerts
        },
        {
            path: '/check-in',
            component: CheckIn
        },
        {
            path: '/location-history',
            component: LocationHistory
        },
        {
            path: '/panic-button',
            component: PanicButton
        },
        {
            path: '/platform-support',
            component: PlatformSupport
        },
        {
            path: '/signup',
            component: SignupScreen,
        },
        {
            path: '/creating-your-profile',
            component: CreatingProfile
        },
        {
            path: '/checkout',
            component: withProps(PlanCheckout, { ...payment }),
        },
        {
            path: '/upsell',
            component: UpsellScreen,
        },
        {
            path: '/success',
            component: SuccessScreen,
        },
    ];

    const {location: {pathname}} = history;

    const locationHistory = useRef([pathname]);

    const setPath = useCallback((path) => {
        dispatch(setActivePage(path.replace('/','')))
    }, [dispatch]);

    useEffect(() => setPath(pathname),[pathname, dispatch, setPath]);

    useEffect(() => {
        history?.listen((newLocation, action) => {
            let {current} = locationHistory,
                path = newLocation.pathname,
                prevPath = current[current.length - 1];

            setPath(path);

            if (path !== prevPath) {
                if (action === "PUSH") {
                    if (!current.includes(path)) {
                        window.scrollTo(0,0);
                        locationHistory.current.push(path);
                        window.sessionStorage.setItem('locationHistory',locationHistory.current);
                    } else {
                        locationHistory.current = current.slice(0,current.indexOf(path)+1);
                        window.sessionStorage.setItem('locationHistory',locationHistory.current);
                    }
                } else {
                    path = prevPath;
                }

                history.push({pathname: path});
            }
        });
    }, [history, setPath]);

    return (
        <Switch>
            {routes.map((route, i) => <Route exact key={i} {...route}/>)}
        </Switch>
    )
};

export default withRouter(Router);
